export default {
  selectedDetails: (state) => state.selectedDetails,
  paymentStatus: (state) => state.paymentStatus,
  selected: (state) => state.selected,
};
